import { Link } from 'react-router-dom';

export default function SafetySection() {
  const tips = [
    {
      title: 'Verify Product Details',
      description: 'Always cross-check product descriptions, images, and seller ratings before making any purchase from a spreadsheet link.',
      icon: 'ri-check-double-line',
    },
    {
      title: 'Protect Personal Information',
      description: 'Use secure payment methods and never share sensitive personal data with unverified sellers or through unofficial channels.',
      icon: 'ri-lock-line',
    },
    {
      title: 'Avoid Fake Resources',
      description: 'Only use community-verified Kakobuy Spreadsheets from trusted sources. Watch for red flags like outdated links or unrealistic prices.',
      icon: 'ri-alert-line',
    },
    {
      title: 'Responsible Shopping',
      description: 'Set a budget, compare prices across platforms, and make informed decisions rather than impulse purchases from spreadsheet finds.',
      icon: 'ri-heart-pulse-line',
    },
  ];

  return (
    <section id="safety" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 text-foreground-600 text-xs font-semibold uppercase tracking-wider mb-4">
            Safety &amp; Trust
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Shop Safely with Confidence
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            We prioritize your safety with verified resources, community reviews, and practical shopping guidelines.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {tips.map((tip) => (
            <div
              key={tip.title}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${tip.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
                {tip.title}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed">
                {tip.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 text-center">
          <h3 className="font-heading text-xl font-bold text-foreground-950 mb-2">
            How We Evaluate Resources
          </h3>
          <p className="text-foreground-600 text-sm max-w-2xl mx-auto leading-relaxed">
            Every Kakobuy Spreadsheet featured on our platform undergoes a rigorous verification process. Our community of experienced shoppers reviews product listings for accuracy, checks seller credibility, monitors pricing trends, and updates the database regularly. We are committed to providing only the most reliable and up-to-date shopping resources available.
          </p>
          <Link
            to="/kakobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Learn More About Our Process
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}